import i18n from "@/i18n";

export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/pages/auth/login.vue"),
    meta: {
      title: i18n.messages[i18n.locale].login.loginTitle,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/pages/auth/register.vue"),
    meta: {
      title: i18n.messages[i18n.locale].register.registerTitle,
    },
  },
  {
    path: "/forget",
    name: "Forget",
    component: () => import("@/pages/auth/forget.vue"),
    meta: {
      title: i18n.messages[i18n.locale].forget.forgetTitle,
    },
  },
  {
    path: "/reset",
    name: "Reset",
    component: () => import("@/pages/auth/reset.vue"),
    meta: {
      title: i18n.messages[i18n.locale].reset.resetTitle,
    },
  },
  {
    path: "/verify",
    name: "Verify",
    component: () => import("@/pages/auth/verify.vue"),
    meta: {
      title: i18n.messages[i18n.locale].verify.verify,
    },
  },

  {
    path: "/remind",
    name: "Remind",
    component: () => import("@/pages/auth/remind.vue"),
    meta: {
      title: i18n.messages[i18n.locale].login.remind.remind,
    },
  },
];
